var map = {
	"./alerts_icon_dark.png": 879,
	"./asset_icon_dark.png": 884,
	"./inventory_icon_dark.png": 892,
	"./item-types-management_icon_dark.png": 894,
	"./management-dashboard_icon_dark.png": 898,
	"./my-facility_icon_dark.png": 901,
	"./notification_icon_dark.png": 902,
	"./purchase-order_icon_dark.png": 906,
	"./shipments_icon_dark.png": 908,
	"./users_icon_dark.png": 917,
	"./work-order_icon_dark.png": 919
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2281;